export function formatMoney(amount, decimalCount = 0, decimal = ".", thousands = ",") {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign +
            (j ? i.substr(0, j) + thousands : '') +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
            (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        console.log(e)
        return '0'
    }
}

import bigInt from "big-integer";

const BASE62_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

// Convert string to hex
function stringToHex(str) {
    const encoder = new TextEncoder();
    return Array.from(encoder.encode(str))
        .map(b => b.toString(16).padStart(2, "0"))
        .join("");
}

// Convert hex to string
function hexToString(hex) {
    const bytes = new Uint8Array(hex.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
    return new TextDecoder().decode(bytes);
}

// Encode a string to base62
export function encodeTextToBase62(str) {
    const hex = stringToHex(str);
    return encodeBase62(hex);
}

// Decode base62 to original string
export function decodeTextFromBase62(base62) {
    const hex = decodeBase62(base62);
    return hexToString(hex);
}

// Encode hex to base62
export function encodeBase62(hex) {
    let num = bigInt(hex, 16);
    if (num.isZero()) return BASE62_ALPHABET[0];

    let base62 = "";
    while (num.gt(0)) {
        const index = num.mod(62).toJSNumber();
        base62 = BASE62_ALPHABET[index] + base62;
        num = num.divide(62);
    }

    return base62;
}

// Decode base62 to hex
export function decodeBase62(base62) {
    let num = bigInt(0);
    for (let char of base62) {
        const index = BASE62_ALPHABET.indexOf(char);
        if (index === -1) throw new Error(`Invalid base62 character: ${char}`);
        num = num.times(62).plus(index);
    }

    let hex = num.toString(16);
    return hex.length % 2 === 1 ? "0" + hex : hex;
}
export async function downloadFile(url) {
    try {
        const response = await fetch(url);
      
        if (!response.ok) throw new Error('Network response was not ok->',response);

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;

        const filename = url.split('/').pop(); // Extract file name from URL
        link.setAttribute('download', filename || 'downloaded-file');

        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
        console.error('Download failed:', err);
    }
}

export function startLoader () {
    this.$Progress.start()
}

export function finishLoader () {
    this.$Progress.finish()
}